import { useVersionCheck } from '../hooks/useVersionCheck'

export function VersionToast() {
  const { hasNewVersion, dismiss } = useVersionCheck()

  if (!hasNewVersion) return null

  return (
    <div className="fixed top-4 right-4 z-50 animate-toast-in">
      <div className="bg-white rounded-lg shadow-lg border border-gray-200 px-4 py-3 flex items-center gap-3">
        <span className="text-sm text-gray-700">New version available</span>
        <button
          onClick={() => window.location.reload()}
          className="text-sm font-medium text-white bg-gray-900 hover:bg-gray-700 px-3 py-1 rounded-md transition-colors"
        >
          Refresh
        </button>
        <button
          onClick={dismiss}
          className="text-gray-400 hover:text-gray-600 text-lg leading-none"
          aria-label="Dismiss"
        >
          ×
        </button>
      </div>
    </div>
  )
}
